export default {
  OPPORTUNITIES: 'opportunities',
  OPPORTUNITY: 'opportunity',
  OPPORTUNITIES_CREATED_BY_ME: 'opportunitiesCreatedByMe',
};
